import { render } from "./CreateIncoming.vue?vue&type=template&id=2c1099dc&scoped=true"
import script from "./CreateIncoming.vue?vue&type=script&lang=js"
export * from "./CreateIncoming.vue?vue&type=script&lang=js"

import "./CreateIncoming.vue?vue&type=style&index=0&id=2c1099dc&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1099dc"]])

export default __exports__